import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import worldPageStore from '@src/pages/main/components/worldPage/store';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';

// import AgeAppropriateTips from '@src/components/age-appropriate-tips';

const styles = require('./index.less');

const worldPage = ({ store }) => {
  store.use();

  const worldViewSwiper = () => {
    if (store.worldViewList?.length > 0) {
      return (
        <div className="worldViewSwiper">
          <BaseSwiper key={store.worldViewSwiper} store={store.worldViewSwiper}>
            {store.worldViewList?.map((item, index) => {
              return (
                <div className={cx('worldViewItem')} key={index}>
                  <div
                    className={cx('worldViewImgs')}
                    style={{
                      backgroundImage: `url(${item.img && item.img})`
                    }}
                  />
                  <div className="delBox">
                    <div className="text">{item.info1}</div>
                    <div className="text">{item.info2}</div>
                  </div>
                  <div className="indicatorText">
                    <div className="title">{item.worldView_title}</div>
                    {/* <div className="subtitle">{item.subtitle}</div> */}
                  </div>
                </div>
              );
            })}
          </BaseSwiper>
        </div>
      );
    }
  };

  return (
    <div className={cx(styles.root, store.isActive && styles.rootAvtive)}>
      {worldViewSwiper()}
      <div className="indicatorBox">
        <Link className="prevBtn" onClick={store.worldViewSwiper.goPrev} />

        <div className="indicator">
          {store.worldViewList?.map((item, index) => {
            return <div key={index} className={cx('indicator-item', store.worldViewSwiper.activeIndex === index && 'indicator-item-act')} />;
          })}
        </div>
        <div className="text">Next </div>
        <Link className="nextBtn" onClick={store.worldViewSwiper.goNext} />
      </div>
    </div>
  );
};

export default wrapStore(worldPage, worldPageStore);
